// Header used in P2P success screen that gives entry-point into mgm flow
import React from 'react'
import glamorous from 'glamorous'
import TermsLink from './termsLink'
import content from 'pp-react-l10n'
import {
  hasMgmSuccessScreenEntryPointTwoTreatment,
  hasMgmSuccessScreenEntryPointThreeTreatment,
} from 'experiments/mgm'
import { Link } from 'react-router-dom'
import { tracking } from 'lib/analytics/mParticle'
import Events from 'lib/analytics/eventTags'
import { formatAmount } from 'transfer/utils/currencyUtils'
import { MGM } from 'transfer/constants'
import PropTypes from 'prop-types'

const i18n = content('transfer/send/success')

const Paragraph = glamorous.p('vx_text-3', {
  fontSize: '15px',
  padding: '0 2rem',
})

export default function MGMEntryPointHeader(props) {
  const { timeZone } = props
  const inVariantTwo = hasMgmSuccessScreenEntryPointTwoTreatment()
  const inVariantThree = hasMgmSuccessScreenEntryPointThreeTreatment()
  const inviteMoreUrl = `/myaccount/transfer/homepage/external/mgm?traffic_source=send_money_success`
  const currencyCode = 'USD'
  const formattedAmount = formatAmount(
    MGM.PROMO_RECEIVE_AMOUNT,
    currencyCode,
    'CURRENCY_FORMAT',
    0
  )
  if (!inVariantTwo && !inVariantThree) {
    return null
  }
  const termsOnClick = () => {
    tracking(Events.p2p_success_mgm_terms_pressed())
  }
  // Variant two contentKey is success.mgmInviteFriendDescWithLink
  // Variant three contentKey is success.mgmInviteFriendDesc
  let contentKey = 'success.mgmInviteFriendDescWithLink'
  if (inVariantThree) {
    contentKey = 'success.mgmInviteFriendDesc'
  }
  return (
    <Paragraph data-nemo="success-subheader">
      {i18n(contentKey, {
        inviteFriendLink: (
          <Link
            to={inviteMoreUrl}
            data-pagename="main:p2p:buy::done"
            onClick={() => tracking(Events.p2p_success_invite_friend_pressed())}
          >
            {i18n('success.mgmInviteFriendLinkLabel')}
          </Link>
        ),
        amountFormatted: formattedAmount,
      })}
      <TermsLink timeZone={timeZone} onClick={termsOnClick} usePeriod={true} />
    </Paragraph>
  )
}

MGMEntryPointHeader.propTypes = {
  timeZone: PropTypes.string.isRequired,
}
